
import { getSessionUserInformation } from "app/utils/utility.service";
import { Menu } from "primereact/menu";
import { Fragment, useRef} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Partials.scss";
import { Card } from "primereact/card";
import { Avatar } from 'primereact/avatar';
import { clearSessionTimeout } from "app/utils/sessionTimeout.service";
import { doLogout } from "app/views/sessions/session.service";

const Header = ({handleSidebar}) => {
    const menu = useRef(null);
    let sessionValues = null;
    try {
        sessionValues = getSessionUserInformation();
    } catch {
        sessionValues = null;
    }
    const navigate = useNavigate();
    const { pathname } = useLocation();
    // Treat any user with a token as logged in; hide user section only on auth pages
    const isAuthPage =
        pathname.startsWith("/session/signin") ||
        pathname.startsWith("/session/signup");
    const showUserSection = !!sessionValues?.token && !isAuthPage;
    const displayName =
        sessionValues?.firstname && sessionValues.firstname.trim()
            ? sessionValues.firstname
            : (sessionValues?.email || "User");

    let items = [
        // {
        //     label: "Home",
        //     command: () => {
        //         window.location.hash = `/`;
        //     },
        // },
        // {
        //     label: "My Applications",
        //     command: () => {
        //         window.location.hash = `/my-applications`;
        //     },
        // },
        // {
        //     label: "My Profile",
        //     command: () => {
        //         window.location.hash = `/my-profile`;
        //     },
        // },
        // {
        //     label: "My Documents",
        //     command: () => {
        //         window.location.hash = `/my-documents`;
        //     },
        // },
        // {
        //     label: "My Qualifcation",
        //     command: () => {
        //         window.location.hash = `/my-qualification`;
        //     },
        // },
        {
            label: "Change Password",
            command: () => {
                navigate("/session/forgot-password");
            },
        },
        {
            label: "Logout",
            command: async () => {
                // SECURITY: Clear session timeout before logout
                clearSessionTimeout();
                // SECURITY: Call backend logout to invalidate token server-side
                await doLogout();
                navigate("/session/signin/step1");
            },
        },
    ];

   
    const valueTemplate = (value) => {
        return (
            <Fragment>
                <span className="text-on-accent"><b>{value}% Profile Completed</b></span>
            </Fragment>
        );
    };


    return (
        <div className="container-fluid">

            <div className="card">
                <Card className="header-card">
                    <div className="Header">

                        <div className="left">
                            <div>
                                <img
                                    src="/nrblogo-removebg.png"
                                    alt="Naturopathy Registration Board (NRB)"
                                    title="Naturopathy Registration Board (NRB)"
                                />
                            </div>
                            
                        </div>
                        <div className="main">
                            <div className="logo_title">
                                <h1 className="mt-0 mb-0 text-center">
                                    NATUROPATHY REGISTRATION BOARD (NRB)
                                </h1>
                                <h4 className="mb-0 mt-0">
                                    <b>under the aegis of National Institute of Naturopathy (NIN)</b>
                                </h4>
                                <h5 className="mt-0 mb-0 text-center">
                                    Ministry of Ayush, Government of India
                                </h5>
                            </div>
                        </div>
                        {showUserSection ? (
                            <Fragment>
                                <div className="right user-info-section">
                                    <div className="user-greeting">
                                        <span className="greeting-text">Welcome back,</span>
                                        <h4 className="user-name">{displayName}</h4>
                                    </div>
                                    <Avatar 
                                        icon="pi pi-user" 
                                        className="user-avatar" 
                                        size="normal" 
                                        style={{ 
                                            backgroundColor: '#093C98', 
                                            color: '#FFFFFF', 
                                            cursor: 'pointer', 
                                            transition: 'var(--transition-base)',
                                            boxShadow: 'var(--shadow-md)'
                                        }}  
                                        shape="circle"  
                                        onClick={(event) => menu.current.toggle(event)}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
                                        }} 
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                                        }} 
                                    />

                                    {/* <h4><i className="pi pi-bars" onClick={handleSidebar} style={{ fontSize: '2rem', cursor:"pointer" }}></i></h4> */}

                                    <Menu
                                        model={items}
                                        popup
                                        ref={menu}
                                        id="popup_menu"
                                    />
                                    {/* <i
                                        className="pi pi-bars ml-2"
                                        style={{
                                            fontSize: "1em",
                                            cursor: "pointer",
                                        }}
                                       
                                        aria-controls="popup_menu"
                                        aria-haspopup
                                    ></i> */}
                                </div>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <div className="right">
                                    {/* <div>
                                        
                                            <h4 >
                                               Ministry of Ayush, Govt. Of India
                                            </h4>
                                    </div> */}
                                    <div>
                                        <img
                                            src="/ministry_of_ayush-removebg.png"
                                            alt="राष्ट्रीय प्राकृतिक चिकित्सा संस्थान, आयुष मंत्रालय, भारत सरकार"
                                            title="राष्ट्रीय प्राकृतिक चिकित्सा संस्थान, आयुष मंत्रालय, भारत सरकार"
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </Card>
                {/* <div className="mt-5">
                <ProgressBar value={getProfileCompletionPercentage(sessionValues)} displayValueTemplate={valueTemplate} />
                </div> */}
            </div>
        </div>
    );
};

export default Header;
